import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';

const API_URL = 'https://api.jsgraceinvestmentsllc.com/api/'; // o tu base real
const API_IMG = 'https://api.jsgraceinvestmentsllc.com/'; // para mostrar imágenes reales


const Airbnb = () => {
    const [propiedades, setPropiedades] = useState([]);


    const [showModal, setShowModal] = useState(false);
    const [selectedPropiedad, setSelectedPropiedad] = useState(null);

    // Form fields
    const [nombre, setNombre] = useState('');
    const [ubicacion, setUbicacion] = useState('');
    const [tipo, setTipo] = useState('');
    const [habitaciones, setHabitaciones] = useState('');
    const [banos, setBanos] = useState('');
    const [capacidad, setCapacidad] = useState('');
    const [precio, setPrecio] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [calificacion, setCalificacion] = useState('');
    const [latitud, setLatitud] = useState('');
const [longitud, setLongitud] = useState('');

    const [imagen, setImagen] = useState(null);

    const [galeria, setGaleria] = useState([]);

    useEffect(() => {
        axios.get(`${API_URL}airbnb`)
            .then(res => {
                const data = res.data.map(p => ({
                    ...p,
                    imagen: p.imagen_principal ? `${API_IMG}${p.imagen_principal}` : 'https://via.placeholder.com/400x250?text=Sin+Imagen'
                }));
                setPropiedades(data);
            })
            .catch(err => {
                console.error('❌ Error al obtener propiedades:', err);
                Swal.fire('Error', 'No se pudo cargar la información', 'error');
            });
    }, []);


    const limpiarCampos = () => {
        setNombre('');
        setUbicacion('');
        setTipo('');
        setHabitaciones('');
        setBanos('');
        setCapacidad('');
        setPrecio('');
        setDescripcion('');
        setCalificacion('');
        setImagen(null);
    };

    const handleGaleriaChange = (e) => {
        const files = Array.from(e.target.files);
        setGaleria((prev) => [...prev, ...files]);
    };

    const handleEliminarPropiedad = (id) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción eliminará la propiedad de forma permanente.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${API_URL}airbnb/${id}`)
                    .then(() => {
                        setPropiedades((prev) => prev.filter((p) => p.id !== id));
                        Swal.fire('Eliminado', 'La propiedad fue eliminada correctamente.', 'success');
                    })
                    .catch((err) => {
                        console.error('❌ Error al eliminar propiedad:', err);
                        Swal.fire('Error', 'No se pudo eliminar la propiedad.', 'error');
                    });
            }
        });
    };


    const removeGaleriaImage = (index) => {
        setGaleria((prev) => prev.filter((_, i) => i !== index));
    };


    const handleGuardar = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('nombre', nombre);
        formData.append('ubicacion', ubicacion);
        formData.append('tipo', tipo);
        formData.append('habitaciones', habitaciones);
        formData.append('banos', banos);
        formData.append('capacidad', capacidad);
        formData.append('precio', precio);
        formData.append('descripcion', descripcion);
        formData.append('calificacion', calificacion);
        formData.append('latitud', latitud);
        formData.append('longitud', longitud);

        if (imagen) {
            formData.append('imagen_principal', imagen);
        }
        galeria.forEach((file) => {
            formData.append('galeria[]', file);
        });

        try {
            const response = await axios.post(`${API_URL}airbnb`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            const nueva = {
                ...response.data.propiedad,
                imagen: `${API_IMG}${response.data.propiedad.imagen_principal}`,
            };

            setPropiedades((prev) => [...prev, nueva]);
            Swal.fire('Guardado', 'Propiedad añadida correctamente', 'success');
            setShowModal(false);
            limpiarCampos();
        } catch (err) {
            console.error('Error al guardar propiedad:', err);
            Swal.fire('Error', 'No se pudo guardar la propiedad', 'error');
        }
    };

    return (
        <div className="container-xxl flex-grow-1 container-p-y">
            <h4 className="pb-3">Propiedades estilo Airbnb</h4>

            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4">
                {propiedades.map((p) => (
                    <div className="col" key={p.id}>
                        <div className="card h-100 shadow-sm">
                            <img
                                src={p.imagen}
                                className="card-img-top"
                                alt={p.nombre}
                                style={{ height: '200px', objectFit: 'cover' }}
                            />
                            <div className="card-body d-flex flex-column">
                                <h5 className="card-title">{p.nombre}</h5>
                                <p className="text-muted mb-1">{p.ubicacion}</p>
                                <p style={{ fontSize: '0.875rem' }}>{p.descripcion}</p>
                                <ul className="list-unstyled small mt-2 mb-2">
                                    <li><strong>Tipo:</strong> {p.tipo}</li>
                                    <li><strong>Habitaciones:</strong> {p.habitaciones}</li>
                                    <li><strong>Baños:</strong> {p.banos}</li>
                                    <li><strong>Capacidad:</strong> {p.capacidad} personas</li>
                                </ul>
                                <div className="mt-auto">
                                    <p className="fw-bold mb-1">${p.precio} / noche</p>
                                    <span className="text-warning">⭐ {p.calificacion}</span>
                                </div>
                                <div className="d-flex align-items-center mt-2">
                                    <button
                                        className="btn btn-primary flex-grow-1 me-2"
                                        onClick={() => {
                                            setSelectedPropiedad(p);
                                            setShowModal(true);
                                        }}
                                    >
                                        Ver detalles
                                    </button>
                                    <button
                                        className="btn btn-danger"
                                        onClick={() => handleEliminarPropiedad(p.id)}
                                    >
                                        <i className="bx bx-trash"></i>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                ))}

                {/* Card para crear nueva */}
                <div className="col">
                    <div
                        className="card shadow"
                        style={{
                            cursor: 'pointer',
                            border: '2px dashed #0d6efd',
                            backgroundColor: '#f8fbff',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        onClick={() => {
                            setSelectedPropiedad(null);
                            setShowModal(true);
                            limpiarCampos();
                        }}
                    >
                        <div className="text-center">
                            <h1 style={{ fontSize: '4rem', color: '#0d6efd' }}>+</h1>
                            <h6 className="mt-2 text-primary">Añadir Propiedad</h6>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal */}
            {showModal && (
                <div
                    className="modal fade show"
                    style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                    tabIndex="-1"
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <form onSubmit={handleGuardar}>
                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        {selectedPropiedad ? 'Detalles de la Propiedad' : 'Nueva Propiedad'}
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => {
                                            setShowModal(false);
                                            setSelectedPropiedad(null);
                                        }}
                                    ></button>
                                </div>

                                <div className="modal-body">
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label">Nombre</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={selectedPropiedad ? selectedPropiedad.nombre : nombre}
                                                onChange={(e) => setNombre(e.target.value)}
                                                readOnly={!!selectedPropiedad}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Ubicación</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={selectedPropiedad ? selectedPropiedad.ubicacion : ubicacion}
                                                onChange={(e) => setUbicacion(e.target.value)}
                                                readOnly={!!selectedPropiedad}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Tipo</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={selectedPropiedad ? selectedPropiedad.tipo : tipo}
                                                onChange={(e) => setTipo(e.target.value)}
                                                readOnly={!!selectedPropiedad}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label">Habitaciones</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={selectedPropiedad ? selectedPropiedad.habitaciones : habitaciones}
                                                onChange={(e) => setHabitaciones(e.target.value)}
                                                readOnly={!!selectedPropiedad}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label">Baños</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={selectedPropiedad ? selectedPropiedad.banos : banos}
                                                onChange={(e) => setBanos(e.target.value)}
                                                readOnly={!!selectedPropiedad}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Capacidad</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={selectedPropiedad ? selectedPropiedad.capacidad : capacidad}
                                                onChange={(e) => setCapacidad(e.target.value)}
                                                readOnly={!!selectedPropiedad}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Precio / noche</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={selectedPropiedad ? selectedPropiedad.precio : precio}
                                                onChange={(e) => setPrecio(e.target.value)}
                                                readOnly={!!selectedPropiedad}
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <label className="form-label">Calificación</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                min="0"
                                                max="5"
                                                step="0.1"
                                                value={selectedPropiedad ? selectedPropiedad.calificacion : calificacion}
                                                onChange={(e) => setCalificacion(e.target.value)}
                                                readOnly={!!selectedPropiedad}
                                            />
                                        </div>
                                        <div className="col-md-6">
    <label className="form-label">Latitud</label>
    <input
        type="text"
        className="form-control"
        value={selectedPropiedad ? selectedPropiedad.latitud : latitud}
        onChange={(e) => setLatitud(e.target.value)}
        readOnly={!!selectedPropiedad}
    />
</div>

<div className="col-md-6">
    <label className="form-label">Longitud</label>
    <input
        type="text"
        className="form-control"
        value={selectedPropiedad ? selectedPropiedad.longitud : longitud}
        onChange={(e) => setLongitud(e.target.value)}
        readOnly={!!selectedPropiedad}
    />
</div>

                                        <div className="col-12">
                                            <label className="form-label">Descripción</label>
                                            <textarea
                                                className="form-control"
                                                rows={3}
                                                value={selectedPropiedad ? selectedPropiedad.descripcion : descripcion}
                                                onChange={(e) => setDescripcion(e.target.value)}
                                                readOnly={!!selectedPropiedad}
                                            />
                                        </div>

                                        {/* Imagen principal */}
                                        {!selectedPropiedad && (
                                            <div className="col-12">
                                                <label className="form-label">Imagen principal</label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    accept="image/*"
                                                    onChange={(e) => setImagen(e.target.files[0])}
                                                />
                                            </div>
                                        )}

                                        {/* Galería de imágenes */}
                                        {!selectedPropiedad && (
                                            <div className="col-12">
                                                <label className="form-label">Galería de imágenes</label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    multiple
                                                    accept="image/*"
                                                    onChange={handleGaleriaChange}
                                                />
                                            </div>
                                        )}

                                        {/* Previsualización galería cargada */}
                                        {!selectedPropiedad && galeria.length > 0 && (
                                            <div className="row mt-2">
                                                {galeria.map((file, index) => (
                                                    <div className="col-md-4 mb-3" key={index}>
                                                        <div className="card">
                                                            <div className="card-body p-2">
                                                                <img
                                                                    src={URL.createObjectURL(file)}
                                                                    alt={`galeria-${index}`}
                                                                    className="img-fluid"
                                                                    style={{ height: '150px', objectFit: 'cover' }}
                                                                />
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-danger mt-2"
                                                                    onClick={() => removeGaleriaImage(index)}
                                                                >
                                                                    Eliminar
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => {
                                            setShowModal(false);
                                            setSelectedPropiedad(null);
                                        }}
                                    >
                                        Cerrar
                                    </button>
                                    {!selectedPropiedad && (
                                        <button type="submit" className="btn btn-primary">
                                            Guardar
                                        </button>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default Airbnb;
